export function getCookie(name) {
  if (process.env.REACT_APP_ENVIRONMENT === "development") {

    return "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzQ1NTcyNjYyLCJleHAiOjE3NDU2NTkwNjIsIm5iZiI6MTc0NTU3MjY2MiwianRpIjoiMFVBbEtueTJtVWVad25VWSIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.1tUuE8jMiLc36RRhKiTlYm6EjJdjspjb3frgUSSyrRk";

  }
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const cookieString = document.cookie; // Get all cookies as a string
  console.log(cookieString)
  const cookies = cookieString.split(";"); // Split into individual cookies

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim(); // Remove leading spaces
    if (cookie.startsWith(name + "=")) {
      if (cookie.substring(name.length + 1) === "") {
        window.location.href = accountsUrl;
      }
      return cookie.substring(name.length + 1); // Return the value of the cookie
    }
  }
  document.cookie = 'redirectPath=' + window.location.href + '; path=/; domain=.mawalog.com';
  document.cookie = 'mawalog=; path=/; domain=.mawalog.com';
  window.location.href = accountsUrl;
  return null; // Return null if the cookie is not found    
}